/**
 * Calculate the new pagination offset when there is a page change in the Pagination component
 * @param {number} page the new page number
 * @param {number} pageSize the page size
 * @returns {string} the new pagination offset, needs to be converted to a string to be used by the request
 */
export const getNewPaginationOffset = (page: number, pageSize: number): string => {
  // the pagination offset is essentially the index (0-based) before the first element the FE wants to fetch
  // for example, with a page size of 10, if the FE wants to fetch items with index 10 - 19, the pagination offset should be "9".
  // If the value is set to undefined or an empty string, the request returns the items on the 1st page (items 0 - 9)
  const newPaginationOffset = page === 1 ? '' : pageSize * (page - 1) - 1;
  return `${newPaginationOffset}`;
};
